import { render } from "./HeroStats.vue?vue&type=template&id=68d490f0&scoped=true"
import script from "./HeroStats.vue?vue&type=script&lang=js"
export * from "./HeroStats.vue?vue&type=script&lang=js"

import "./HeroStats.vue?vue&type=style&index=0&id=68d490f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d490f0"]])

export default __exports__